import PropTypes from 'prop-types';
import { Component } from 'react';

import {
  LINK_WITH_ALEXA_BUTTON_LABEL,
  LINKED_WITH_ALEXA_BUTTON_LABEL,
} from 'src/common/constants/localizations/devices';
import withAlexaLinking from '../../../decorators/withAlexaLinking';
import { LocationAndLocalizationContext } from '../../../providers/LocationAndLocalizationProvider';
import PillButton from './PillButton';

// exported for testing
export class AlexaLinkButton extends Component {
  static propTypes = {
    isAlexaLinked: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string.isRequired,
    isAlexaLinkingEnabled: PropTypes.bool,
    onMount: PropTypes.func,
  };

  static contextType = LocationAndLocalizationContext;

  componentDidMount() {
    const { onMount, isAlexaLinkingEnabled } = this.props;

    onMount?.(isAlexaLinkingEnabled);
  }

  render() {
    const { onClick, isAlexaLinked, className, isAlexaLinkingEnabled } = this.props;
    const { getLocalizedText } = this.context;

    const alexaButtonLabelKey = isAlexaLinked
      ? LINKED_WITH_ALEXA_BUTTON_LABEL
      : LINK_WITH_ALEXA_BUTTON_LABEL;

    if (!isAlexaLinkingEnabled) {
      return null;
    }

    return (
      <PillButton
        id="addAlexa"
        dataTestId="addAlexa"
        className={className}
        onClick={onClick}
        label={getLocalizedText(alexaButtonLabelKey)}
        isDisabled={isAlexaLinked}
      />
    );
  }
}

export default withAlexaLinking(AlexaLinkButton);
